export interface VerificationProfileStatusResponse {
  basicVerificationStatus: BasicVerificationStatus;
  idVerificationStatus: IDVerificationStatus;
  basicTrialExpirationDate: string; // Date
  statusWidgetDisplayExpirationDate: string; // Date
  isBasicFormPassed: boolean;
}

export enum BasicVerificationStatus {
  none, // initial state
  trial, // the form is sent, and 30 days are not passed
  expired, // the form is sent, and 30 days are passed
  accepted, // final state
  basicFormPassed, // the form is sent, email wasn't confirmed
}

export enum IDVerificationStatus {
  none, // initial state
  started, // user has opened sumsub page for at least once
  pending, // the form is sent, but decision is not accepted yet
  rejected, // the data was declined. Potentially can lead to switch flow from auto to manual
  banned, // final rejection, the user cannot deal with us
  accepted, // final accept, all restrictions vanished
}
